import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageHeaderComponent } from '../../atoms/page-header/page-header.component';
import { InfoCardComponent } from '../../molecules/info-card/info-card.component';

@Component({
  selector: 'ui-administration-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    PageHeaderComponent,
    InfoCardComponent,
  ],
  template: `
    <ng-container *transloco="let t">
      <ui-page-header [class]="'bg-[#86a5c2]'">
        <div class="col-span-12">
          <ui-info-card
            [title]="t('ADMIN.LABEL')"
            icon="code-sandbox"
            [iconClasses]="'text-indigo-800'"
          >
          </ui-info-card>
        </div>
      </ui-page-header>
    </ng-container>
  `,
})
export class AdministrationHeaderComponent {
}
